/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RateUpdateResponse
 */
export interface RateUpdateResponse {
    /**
     * The ID of the rebooking request.
     * @type {number}
     * @memberof RateUpdateResponse
     */
    id?: number;
    /**
     * The ID of the user this rebooking request belongs to.
     * @type {string}
     * @memberof RateUpdateResponse
     */
    userId?: string;
    /**
     * The ID of the hotel stay this rebooking request belongs to.
     * @type {string}
     * @memberof RateUpdateResponse
     */
    hotelStayId: string;
    /**
     * The ID of the payment this rebooking request belongs to.
     * @type {string}
     * @memberof RateUpdateResponse
     */
    paymentId?: string;
    /**
     * The status of the rebooking request.
     * @type {string}
     * @memberof RateUpdateResponse
     */
    status: RateUpdateResponseStatusEnum;
    /**
     * The Gondola rate ID for the current price. Present when status is MANUAL_UPDATE_REQUIRED.
     * @type {number}
     * @memberof RateUpdateResponse
     */
    gondolaRateId?: number;
    /**
     * The timestamp of when the rebooking request was created.
     * @type {Date}
     * @memberof RateUpdateResponse
     */
    createdAt?: Date;
    /**
     * The timestamp of when the rebooking request was last updated.
     * @type {Date}
     * @memberof RateUpdateResponse
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const RateUpdateResponseStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    ManualUpdateRequired: 'MANUAL_UPDATE_REQUIRED'
} as const;
export type RateUpdateResponseStatusEnum = typeof RateUpdateResponseStatusEnum[keyof typeof RateUpdateResponseStatusEnum];


/**
 * Check if a given object implements the RateUpdateResponse interface.
 */
export function instanceOfRateUpdateResponse(value: object): value is RateUpdateResponse {
    if (!('hotelStayId' in value) || value['hotelStayId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RateUpdateResponseFromJSON(json: any): RateUpdateResponse {
    return RateUpdateResponseFromJSONTyped(json, false);
}

export function RateUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateUpdateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'hotelStayId': json['hotel_stay_id'],
        'paymentId': json['payment_id'] == null ? undefined : json['payment_id'],
        'status': json['status'],
        'gondolaRateId': json['gondola_rate_id'] == null ? undefined : json['gondola_rate_id'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function RateUpdateResponseToJSON(json: any): RateUpdateResponse {
    return RateUpdateResponseToJSONTyped(json, false);
}

export function RateUpdateResponseToJSONTyped(value?: RateUpdateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'hotel_stay_id': value['hotelStayId'],
        'payment_id': value['paymentId'],
        'status': value['status'],
        'gondola_rate_id': value['gondolaRateId'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

